import React from "react";

export const ShareIcon = React.memo(({size = 31}: {size?: any}) => {
    return (
        <svg width={size} height={size - 10} viewBox="0 0 31 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.8333 18.375C27.2542 18.375 28.4037 17.1938 28.4037 15.75L28.4167 2.625C28.4167 1.16813 27.2542 0 25.8333 0H5.16667C3.73292 0 2.58333 1.16813 2.58333 2.625V15.75C2.58333 17.1938 3.73292 18.375 5.16667 18.375H0V21H31V18.375H25.8333ZM16.7917 13.7419V10.8675C13.2008 10.8675 10.8371 11.9831 9.04167 14.4375C9.765 10.9331 11.7671 7.44187 16.7917 6.73313V3.9375L21.9583 8.83312L16.7917 13.7419Z" fill="white"/>
        </svg>)
});